export default __webpack_public_path__ + "static/media/c002-PPII-7.57b1a25d.svg";